const productForm = document.querySelector('.product-form');
const addOnProducts = document.querySelectorAll('.add-on-product');
const addOnInfoButtons = document.querySelectorAll('.add-on-product__info-btn');
const closeAddOnModalButtons = document.querySelectorAll('.add-on-modal__close');

addOnInfoButtons.forEach(btn => {
   btn.addEventListener('click', (e) => {
      const modalId = e.target.getAttribute('data-add-on-id');
      const addOnModal = document.querySelector(`#${modalId}`);
      addOnModal.classList.add('show');
   })
})

closeAddOnModalButtons.forEach(btn => {
   btn.addEventListener('click', () => {
      document.querySelectorAll('.add-on-modal-wrapper').forEach(item => {
         item.classList.remove('show')
      })
   })
})

addOnProducts.forEach(product => {
  const colors = product.querySelector('.add-on-product__color-selector');
  const input = product.querySelector('.add-on-product__input')
  input.addEventListener('change', () => {
    const addOnPrice = +input.getAttribute('data-add-on-price')
    let variantPrice = +document.querySelector('[data-current-variant-price]').getAttribute('data-current-variant-price')

    colors.classList.toggle('show')

    if(input.checked) {
      variantPrice = variantPrice + addOnPrice;
      document.querySelector('[data-current-variant-price]').setAttribute('data-current-variant-price', variantPrice)
    } else {
      variantPrice = variantPrice - addOnPrice;
      document.querySelector('[data-current-variant-price]').setAttribute('data-current-variant-price', variantPrice)
    }

    const addToCartBtnText = document.querySelector('.product-form__cart-submit span')
    const priceElement = document.querySelector('.product-single__price')
    addToCartBtnText.innerHTML = `${theme.strings.addToCart} <span style="margin: 0 10px;">–</span>${Shopify.formatMoney(variantPrice, theme.moneyFormat)}`
    priceElement.innerHTML = theme.Currency.formatMoney(variantPrice, theme.moneyFormat)
  })
})

productForm.addEventListener('submit', function(e) {
  e.preventDefault();
  const items = [];
  const currenItem = {};    
  currenItem.id = parseInt(document.querySelector('[data-current-variant-id]').getAttribute('data-current-variant-id'));
  currenItem.quantity = document.querySelector('.js-qty #Quantity').value;
  items.push(currenItem);

  addOnProducts.forEach(product => {
    const item = {};
    product.querySelectorAll('input').forEach(input => {
      console.log(input)
      if(input.checked) {
        const quantity = parseInt(input.closest(".add-on-product").querySelector('input.js-qty__input').value)
        item.id = parseInt(input.getAttribute('id'));
        item.quantity = quantity || 1;
      }
    })    
    if(item.hasOwnProperty('id')) {
      items.push(item);
    } 
  })

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({items: items})
  })
  .then(res => res.json())
  .then(data => {
    theme.miniCart.updateElements();
    theme.miniCart.generateCart();
    theme.miniCart.showCartModal()
    //theme.crosssell.showPopup(data.items.filter(item => item.id === +currenItem.id)[0])
  })
  .catch(error => {
    console.log(error)
  })
})
